import type { MobilisationEvent } from '@hcc/types';
import { EventTimeline } from '../../../components/person/EventTimeline';
import { MetadataPanel } from '../../../components/person/MetadataPanel';

export function HistoryTab({
  personId,
  metadata,
  events,
}: {
  personId: string;
  metadata: Record<string, unknown>;
  events: MobilisationEvent[] | null;
}) {
  return (
    <>
      <EventTimeline events={events} personId={personId} />
      <MetadataPanel metadata={metadata} />
    </>
  );
}
